export const shake = (target: Element, cssClass: String, duration: number): void => {
  target.classList.add(cssClass)
  setTimeout(() => {
    target.classList.remove(cssClass)
  }, duration)
}
